// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Sheet from "../../primitives/Sheet.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Accounting__Utils from "@wino/accounting/src/Accounting__Utils.res.js";
import * as OrderCartCsvExporting__Utils from "./OrderCartCsvExporting__Utils.res.js";

function purchaseOrder(statuses) {
  let match = statuses[0];
  if (match !== undefined) {
    return match !== "RECEIVED" && match !== "RECEIVING";
  } else {
    return true;
  }
}

function makeFilename(statuses, name) {
  return I18n.t(purchaseOrder(statuses) ? "purchaseorder" : "receiptorder") + ("_" + (name.replace("N°", "") + ".csv"));
}

function currencyFormat(value) {
  return I18n.currencyFormat(undefined, "EUR", 3, 3, value);
}

function makePlainText(cart, name, statuses, supplierName, supplierAddress, supplierPostalCode, supplierCity, supplierCountry) {
  let titleRow = [[I18n.template(I18n.t("Order{{entilted}}{{name}}"), {
        entilted: " ",
        name: name
      }, undefined) + (" - " + I18n.t(purchaseOrder(statuses) ? "Purchase order" : "Order receipt"))]];
  let supplierHeader = [I18n.t("Supplier's informations") + " :"];
  let supplierRow = supplierAddress === "" ? supplierPostalCode + ` ` + supplierCity + ` ` + supplierCountry : supplierAddress + `, ` + supplierPostalCode + ` ` + supplierCity + ` ` + supplierCountry;
  let fees = cart.fees;
  let feeHeaders = fees !== undefined ? fees.map(fee => OrderCartCsvExporting__Utils.kindToHeaderText(fee.kind)) : [I18n.t("U. fees")];
  let match = cart.taxesFree;
  let headers = Belt_Array.concatMany([
    [
      "SKU",
      I18n.t("Product's name"),
      I18n.t("Description"),
      I18n.t(purchaseOrder(statuses) ? "Ordered quantity" : "Received quantity"),
      I18n.t("Packaging"),
      I18n.t("U. price excl. VAT"),
      I18n.t("Discount")
    ],
    feeHeaders,
    match ? [] : [I18n.t("VAT")],
    [I18n.t("Total excl. VAT")]
  ]);
  let productRows = cart.products.map(product => {
    let match;
    if (product.TAG === "Unit") {
      let product$1 = product._0;
      match = [
        product$1.stockKeepingUnit,
        product$1.name,
        product$1.description,
        product$1.formattedQuantity,
        Stdlib_Option.map(product$1.packaging, prim => prim),
        currencyFormat(product$1.unitPrice),
        Stdlib_Option.map(Stdlib_Option.map(product$1.totalDiscounts, prim => prim.toNumber()), currencyFormat),
        product$1.fees,
        product$1.taxes,
        Stdlib_Option.map(Stdlib_Option.map(product$1.totalAmountExcludingTaxes, prim => prim.toNumber()), currencyFormat)
      ];
    } else {
      let product$2 = product._0;
      match = [
        product$2.stockKeepingUnit,
        product$2.name,
        product$2.description,
        product$2.formattedQuantity,
        Stdlib_Option.map(product$2.packaging, prim => prim.toNumber()),
        currencyFormat(product$2.unitPrice),
        Stdlib_Option.map(Stdlib_Option.map(product$2.totalDiscounts, prim => prim.toNumber()), currencyFormat),
        product$2.fees,
        product$2.taxes,
        Stdlib_Option.map(Stdlib_Option.map(product$2.totalAmountExcludingTaxes, prim => prim.toNumber()), currencyFormat)
      ];
    }
    let productTaxes = match[8];
    let match$1 = cart.taxesFree;
    return Belt_Array.concatMany([
      [
        Stdlib_Option.getOr(match[0], ""),
        match[1],
        match[2],
        Stdlib_Option.getOr(match[3], ""),
        Stdlib_Option.mapOr(match[4], "", packaging => packaging.toString()),
        Stdlib_Option.getOr(match[5], ""),
        Stdlib_Option.getOr(match[6], "")
      ],
      OrderCartCsvExporting__Utils.getFeesRowData(match[7], cart.fees),
      productTaxes !== undefined ? (
          match$1 ? [] : [OrderCartCsvExporting__Utils.formattedTaxRates(productTaxes)]
        ) : [],
      [Stdlib_Option.getOr(match[9], "")]
    ]);
  });
  let formattedTotalAmountExcludingTaxes = currencyFormat(Accounting__Utils.bigToFloat(Stdlib_Option.getOrThrow(cart.totalAmountExcludingTaxes, undefined)));
  let formattedTotalAmountIncludingTaxes = currencyFormat(Accounting__Utils.bigToFloat(Stdlib_Option.getOrThrow(cart.totalAmountIncludingTaxes, undefined)));
  let formattedTotalTaxes = currencyFormat(Accounting__Utils.bigToFloat(Stdlib_Option.getOrThrow(cart.totalTaxes, undefined)));
  let totalsRows = Stdlib_Array.reduce(cart.taxesFree ? [[[
          I18n.t("Total amount excl. VAT"),
          formattedTotalAmountIncludingTaxes
        ]]] : [
      [[
          I18n.t("Excl. VAT total"),
          formattedTotalAmountExcludingTaxes
        ]],
      Stdlib_Option.getOrThrow(cart.taxes, undefined).filter(tax => {
        let amount = tax.amount;
        if (amount !== undefined) {
          return Accounting__Utils.bigToFloat(Primitive_option.valFromOption(amount)) > 0;
        } else {
          return false;
        }
      }).map(tax => {
        let formattedTaxAmount = currencyFormat(Accounting__Utils.bigToFloat(Stdlib_Option.getOrThrow(tax.amount, undefined)));
        let formattedTaxRate = I18n.percentFormat(undefined, undefined, 2, tax.rate / 100);
        return [
          I18n.t("VAT") + " " + formattedTaxRate,
          formattedTaxAmount
        ];
      }),
      [[
          I18n.t("VAT total"),
          formattedTotalTaxes
        ]],
      [[
          I18n.t("Total amount incl. VAT"),
          formattedTotalAmountIncludingTaxes
        ]]
    ], [], (acc, arr) => Belt_Array.concatMany([
    acc,
    arr
  ]));
  return Sheet.makeCsvPlainText(undefined, Belt_Array.concatMany([
    titleRow,
    [
      [],
      supplierHeader,
      [supplierName],
      [supplierRow.trim()],
      [],
      headers.filter((param, idx) => productRows.some(row => row[idx] !== ""))
    ],
    productRows.map(row => row.filter((param, idx) => productRows.some(row => row[idx] !== ""))),
    [[]],
    totalsRows
  ]));
}

function makeBlob(cart, name, statuses, supplierName, supplierAddress, supplierPostalCode, supplierCity, supplierCountry) {
  return Stdlib_Result.map(makePlainText(cart, name, statuses, supplierName, supplierAddress, supplierPostalCode, supplierCity, supplierCountry), Sheet.makeCsvBlobFromPlainText);
}

let Utils;

let bigToFloat = Accounting__Utils.bigToFloat;

export {
  Utils,
  purchaseOrder,
  makeFilename,
  bigToFloat,
  currencyFormat,
  makePlainText,
  makeBlob,
}
/* I18n Not a pure module */
